

























import {Component, Prop, Vue} from 'vue-property-decorator';
import Modal from '@/layouts/back-office/elements/modals/Modal.vue';

@Component({
  components: {Modal},
})

export default class TaskExplanation extends Vue {

  @Prop(Object) public task!: any;


}
